export default "__VITE_ASSET__a6b707ff__"